import * as React from "react"
import img from '../../../images/edgeAnimations/MastheadAnimations.png'
import Layout from "../../../components/layout"
import * as style from './index.module.scss'
import IndustryLeader from "../../../components/industryLeader"
import styled from 'styled-components'
import MHContainer from "../../../components/masthead/mhContainer"
import MHALink from "../../../components/masthead/mhALink"
import MHNameText from "../../../components/masthead/mhNameText"
import MHDescriptionText from "../../../components/masthead/mhDescriptionText"
import BasicModal from "../../../components/modal/basicModal"
import { useEffect } from "react"
import $ from 'jquery';
import Educational from "../../../images/edgeAnimations/Educational.jpg"
import Marketable from "../../../images/edgeAnimations/Marketable.png"
// import "../../../styles/animations.css"

import { Seo } from "../../../components/seo"
import DemoFormContainer from "../../../components/demoFormContainer"
import EACarousel from "../../../components/ourSolutions/EACarousel"
import EASeeForYourself from "../../../components/ourSolutions/EASeeForYourself"
import { UseVideoLinks } from '../../../hooks/use-video-links';

const EdgeAnimationsWrapper = styled.div`
overflow: hidden;
background: #ffffff url(${ img });
background-position: center;
background-repeat:no-repeat;
background-attachment: fixed;
background-size: cover;
height: 76vh;
padding: 3rem 0;

@media (min-width: 768px) {
      background-attachment: fixed;
      padding: 5rem;
  }

@media (min-width: 1600px) {
      padding: 14rem;
}
`;

const IndexPage = ({location}) => {
    const { edge_Animations_Demo } = UseVideoLinks()
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const testQS = params.get("success");
        if(testQS === "true")
          $('#EAModal').modal('show');
        }, [location.search]); 
  return (
    <>
    <EdgeAnimationsWrapper>
    <MHContainer>
      <MHNameText name="Edge Animations"></MHNameText>
      <h1 className={style.mastheadH1}>Your Treatment Animated</h1>
      <MHDescriptionText description="Enhance your practice with powerful education videos"></MHDescriptionText>
      <p className="pt-2 pb-2">
        <MHALink whereTo="#AnimationsDemoForm" btnClass="btnEAnimations" linkText="Request a Demo"></MHALink>
        <MHALink whereTo={ edge_Animations_Demo } btnClass="btnEAnimations ml-3" rel="noreferrer" target="_blank" linkIcon="far fa-play-circle" linkText="Watch an Overview" ></MHALink>
      </p>
    </MHContainer>
    </EdgeAnimationsWrapper>
    <div id="More" className={style.moreSection}>
    <div className="container">
        <h2 className="text-center">Experience the Power of<br /> Edge Animations!</h2>
        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
            <div className="col-12">
                <div className={style.moreTextNoBorderExperienceThePower}>
                    <p className="text-black-50 mb-0">Revolutionize the way you communicate with your patients. Ensure your patients are fully informed about their treatment with videos from our ever-expanding library of resources. Powerful surgical and true 3D animations can be shown as is, or customized with annotations, narration, or background music.</p>
                </div>
            </div>
        </div>

        <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
            <div className="col-lg-6 text-center align-self-md-end">
                <img className="img-fluid" src={ Educational } alt="Educational videos for your pediatric dental and orthodontic patients." />
            </div>
            <div className="col-lg-6">
                <div className="bg-light-gray text-center h-100 Details">
                    <div className="d-flex h-100">
                        <div className={style.moreTextNoBorderEducational}>
                            <h4>Educational</h4>
                            <p className="mb-0">Show patients and parents what to expect with various videos such as brushing, foods to avoid, extractions, TADs, and more. Add in your specific patient’s images and treatment findings to make a completely customizable video.</p>
                            <hr className={style.hrEducational} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row justify-content-center no-gutters">
            <div className="col-lg-6 text-center">
                <img className="img-fluid" src={ Marketable } alt="Marketable videos for your pediatric dental and orthodontic patients." />
            </div>
            <div className="col-lg-6 order-lg-first">
                <div className="bg-light-gray text-center h-100 Details">
                    <div className="d-flex h-100">
                        <div className={style.moreTextNoBorderMarketable}>
                            <h4>Marketable</h4>
                            <p className="mb-0">Export files to easily email to responsible parties, or upload to Facebook or YouTube. Be creative with Animations – take a few snap shots of your caring and dedicated staff, and some music to your filmstrip and you have a fun, creative promotional video. The possibilities are endless!</p>
                            <hr className={style.hrMarketable} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
    <EACarousel></EACarousel>
    <EASeeForYourself></EASeeForYourself>
    <div id="AnimationsDemoForm" style={{ height:50 }}></div>
    <DemoFormContainer id="DemoForm" header="Request a Demo" title="Request an Edge Animations Demo" height="500" src="https://go.ortho2.com/l/1001731/2022-12-21/4hph"></DemoFormContainer>
    <IndustryLeader name='Dr. Christos Papadopoulos' location='Orthodontist at Papadopsmiles Orthodontics' quote='"When selecting a practice management software, I had countless hours of calls speaking to various companies. Ortho2 was the most robust system that fit my needs as an orthodontic start-up without having to rely on other third-party softwares. Ortho2 does it all and we are very happy with our decision."'></IndustryLeader>
    <BasicModal modalId="EAModal" titleMessage="THANK YOU!">
        <p>
            Thank you for submitting your question or comment. An Ortho2 Regional Manager will be in contact with you soon.
        </p>
    </BasicModal>
    </>
  )
}
IndexPage.Layout = Layout
export default IndexPage

export const Head = () => (<Seo title="Ortho2 - Orthodontic and Pediatric Animations - Edge Animations Software" />)